import React, { useEffect, useState } from "react";
import { GetCurrentUser } from "../../Services/LoginService";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import ThemeToggle from "../Common/ThemeToggle";

const Header = ({ onMenuToggle }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
  });

  useEffect(() => {
    const savedName = Cookies.get("Orbit_UserName");
    const savedEmail = Cookies.get("Orbit_UserEmail");

    if (savedName && savedEmail) {
      setUser({
        name: savedName,
        email: savedEmail,
      });
      return;
    }

    const fetchUser = async () => {
      try {
        const result = await GetCurrentUser();

        if (result?.status === "Success") {
          const userData = {
            name: result.data.name,
            email: result.data.email,
          };

          setUser(userData);
          Cookies.set("Orbit_UserName", result.data.name, { expires: 30 });
          Cookies.set("Orbit_UserEmail", result.data.email, { expires: 30 });
          Cookies.set("Orbit_PMCount", result.data.pmCount, { expires: 30 });
          Cookies.set("Orbit_DevCount", result.data.developerCount, {
            expires: 30,
          });
          Cookies.set("Orbit_TesterCount", result.data.testerCount, {
            expires: 30,
          });
        }
      } catch (error) {
        if (error.response?.status === 400) {
          navigate("/bad-request", {
            state: {
              error: error.response?.data?.message || "Bad request (400)",
            },
          });
          return;
        }
        console.error("Failed to fetch user:", error.message);
      }
    };

    fetchUser();
  }, [navigate]);

  //  Generate initials
  const getInitials = (fullName) => {
    if (!fullName) return "";
    const parts = fullName.trim().split(" ");
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

    return (
      parts[0].charAt(0).toUpperCase() +
      parts[parts.length - 1].charAt(0).toUpperCase()
    );
  };

  const initials = getInitials(user.name);

  const location = useLocation();
  const path = location.pathname;

  const getPageTitle = () => {
    if (path === "/home" || path === "/Report") return "Welcome to Dashboard";

    const segments = path.split("/").filter(Boolean);

    const last = segments[segments.length - 1];

    return last.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <header className="w-full bg-white shadow-sm px-4 py-3 sm:px-5 lg:px-6 flex flex-wrap justify-between gap-3 items-center theme-topbar">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={onMenuToggle}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 text-gray-600 transition hover:bg-gray-100 lg:hidden"
          aria-label="Open navigation menu"
        >
          <Menu size={20} />
        </button>
        <h1 className="truncate text-base font-semibold text-gray-700 sm:text-lg">
          {getPageTitle()}
        </h1>
      </div>

      <div className="ml-auto flex items-center gap-3 sm:gap-4">
        <ThemeToggle />

        {/* User Info */}
        <div className="flex items-center space-x-3 min-w-0">
          {/* Circle Initials */}
          <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white flex items-center justify-center font-semibold text-sm shadow">
            {initials || "US"}
          </div>

          <div className="hidden sm:block min-w-0">
            <p className="truncate text-sm font-semibold">
              {user.name || "Loading..."}
            </p>
            <p className="truncate text-xs text-gray-500">{user.email || ""}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
